import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import dayjs from 'dayjs'
import { z } from 'zod'
import weekOfYear from 'dayjs/plugin/weekOfYear'
dayjs.extend(weekOfYear)

export const Prd2010SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    lotNo: z.string().optional(),
    partyId: z.string().optional(),
    itemId: z.string().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    mfgDate: z
      .string()
      .optional()
      .transform((val) => {
        if (val === undefined) return dayjs().toDate()
        if (val === 'null') return null
        return new Date(val)
      })
      .nullable(),
    MfgYear: z.number().optional(),
    MfgWeek: z.number().optional(),
    machine: z.string().optional(),
    onlyNotCompleted: z.coerce.boolean().optional(),
  })
  .merge(BasePaginateParamsSchema)
  .transform((values) => ({
    ...values,
    mfgYear: values.mfgDate ? dayjs(values.mfgDate).isoWeekYear() : null,
    mfgWeek: values.mfgDate ? dayjs(values.mfgDate).isoWeek() : null,
  }))

export type Prd2010SearchParams = z.infer<typeof Prd2010SearchParamsSchema>

export const Prd2010SearchResultModelSchema = z.object({
  id: z.number(),
  deliveryDate: z.coerce.date(),
  deliveryWeekNo: z.number().int(),
  productionDate: z.coerce.date(),
  productionWeekNo: z.number().int(),
  partyId: z.number(),
  partyName: z.string(),
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  qty: z.number(),
  number: z.string(),
  lotNo: z.string().nullable(),
  productionType: z.string().nullable(),
  machine: z.string().nullable(),
  startDate: z.coerce.date().nullable(),
  endDate: z.coerce.date().nullable(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  isTestProduction: z.boolean(),
  fgToWarQty: z.number(),
  fgRemainingToWarQty: z.number(),
  fgToWars: z.array(
    z.object({
      id: z.number(),
      date: z.coerce.date(),
      qty: z.number(),
      cancelled: z.boolean(),
      inventoryConfirmed: z.boolean(),
      inventoryDocId: z.number().nullable(),
      inventoryDocNumber: z.string().nullable(),
    })
  ),
})

export type Prd2010SearchResultModel = z.infer<
  typeof Prd2010SearchResultModelSchema
>

export const Prd2010SearchResultSchema = z
  .object({
    data: z.array(Prd2010SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Prd2010SearchResult = z.infer<typeof Prd2010SearchResultSchema>
